import { getAuth } from "firebase/auth";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { createProject, getProjectDetails, addProjectNote } from "../firebase/controller/project";
import { getProjects } from "../firebase/controller/vault";
import { uploadProject } from "../utils";

const ProjectContext = React.createContext();

export function useProject() {
  return useContext(ProjectContext);
}

export function ProjectProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [claim] = useState(null);
  const [ selectedProject, setSelectedProject ] = useState({});
  const [loader, setLoader] = useState(false);
  const [mediaURLs, setMediaURLs] = useState([]);
  const [uploadImage, setUploadImage] = useState(null);
  const [values, setValues] = useState();
  const [ details, setDetails ] = useState([]);
  const [ projects, setProjects ] = useState([]);


  const createproject = useCallback(
    async (status) => {
      if (uploadImage) {
        uploadProject(uploadImage, mediaURLs, setMediaURLs, setLoader, status, async () => {
          const res = await createProject({ ...values, media: mediaURLs, lastUpdate: new Date().toISOString().split("T")[0] });
          res && toast.success("project added successfully.");
          window.location.reload(false)
          setDone(true);
          setLoader(false);
        });
      }
    },
    [uploadImage, mediaURLs, values]
  );

  useEffect(() => {
    selectedProject && getDetails(selectedProject?.nickName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject]);

  const getDetails = async (selectedProject) => {
    try {
      setLoader(true);
      const res = await getProjectDetails(selectedProject);
      setDetails(res);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      const message = error.message;
      toast.error(message);
    }
  };

  const getprojects = async () => {
    try {
      setLoader(true);
      const res = await getProjects();
      setProjects(res);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      const message = error.message;
      toast.error(message);
    }
  };

  const addprojectnote = async (data) => {
    try {
      setLoading(true);
      const res = await addProjectNote({ ...data, projectName: selectedProject?.nickName });
      res && toast.success("Detail sent successfully.");
      setLoading(false);
      setDone(true);
    } catch (error) {
      toast.error("There is an error adding project detail, try again");
      setLoading(false);
      setDone(true);
    }
  }

  useEffect(() => {
    (async function () {
      if (uploadImage && mediaURLs.length === Array.from(uploadImage).length) {
        await createproject(true);
      }
    })();
  }, [createproject, mediaURLs.length, uploadImage]);

  useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged((user) => {
      if (user) {
        getprojects();
      }
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(projects.length > 0){
      setSelectedProject(projects[0])
    }
  }, [projects]);

  const value = {
    loading,
    setLoading,
    done,
    getprojects,
    projects,
    setDone,
    setUploadImage,
    setValues,
    loader,
    claim,
    details,
    setSelectedProject,
    selectedProject,
    createproject,
    uploadImage,
    addprojectnote,
  };

  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
}
